import {
  cloneDeep,
  mergeWith,
  throttle,
  debounce,
  tail,
  set,
  get,
  transform,
  isEqual,
  isObject,
  pick,
  groupBy,
  camelCase
} from 'lodash-es'

export {
  cloneDeep,
  mergeWith,
  throttle,
  debounce,
  set,
  get,
  transform,
  isEqual,
  isObject,
  pick,
  groupBy,
  camelCase
}

export const merge = function () {
  return mergeWith(arguments[0], ...tail(arguments), (objValue, srcValue) => {
    if (Array.isArray(objValue)) {
      return srcValue
    }
  })
}

export const objectToFormdata = (obj, form, namespace) => {
  let fd = form || new FormData()
  let formKey

  for (let property in obj) {
    if (obj.hasOwnProperty(property)) {
      let key = Array.isArray(obj) ? `[${property}]` : `.${property}`
      if (namespace) {
        formKey = namespace + key
      } else {
        formKey = property
      }

      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString())
      } else if (
        typeof obj[property] === 'object' &&
        !(obj[property] instanceof File)
      ) {
        objectToFormdata(obj[property], fd, formKey)
      } else if (obj[property] !== undefined) {
        fd.append(formKey, obj[property])
      }
    }
  }

  return fd
}

export const mergeArrObj = function (arr, baseprop) {
  let result = arr.reduce((groups, item) => {
    let groupFound = groups.find(arrItem => arrItem[baseprop] === item[baseprop])
    if (groupFound) {
      delete item[baseprop]
      groupFound.list.push(item)
    } else {
      // 不要直接在原来的对象修改，新建对象
      var newGroup = {}
      newGroup[baseprop] = item[baseprop]
      delete item[baseprop]
      newGroup.list = [item]
      groups.push(newGroup)
    }
    return groups
  }, [])
  return result
}
